<template>
  <div>
    <custom-label v-if="label" :item-field-name="label" />

    <v-autocomplete
      dense
      filled
      class="autoCompleted"
      rounded
      v-bind="$attrs"
      :items="list"
      v-on="$listeners"
      :search-input.sync="search"
      hide-details="auto"
      :value="value"
      @input="x => $emit('input', x)"
      :disabled="disabled"
      no-filter
      :prepend-inner-icon="icon"
      :background-color="$vuetify.theme.themes.light.inputBackgroundColor"
    >
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
        <slot :name="name" v-bind="props" />
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { crudList } from '@/api/crud';
import api from '@/api';
import { debounce } from 'lodash';
import customLabel from '@/components/customFormLabel/customLabel';
export default {
  name: 'masterAutocomplete',
  components: {
    customLabel,
  },
  props: {
    path: {},
    value: {},
    params: {},
    disabled: { type: Boolean, default: false },
    icon: {
      type: String,
      default: 'mdi-magnify',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      search: null,
      debounceToGetData: debounce(this.reload, 500),
    };
  },
  methods: {
    async reload() {
      const _list = (await crudList(api, this.path, { search: this.search, ...this.params })).docs;

      const itemValuePropertyName = this.$attrs['item-value'];
      if (
        this.value &&
        itemValuePropertyName &&
        !_list.find(
          item =>
            item[itemValuePropertyName] === this.value ||
            item[itemValuePropertyName] === this.value?.[itemValuePropertyName],
        )
      ) {
        _list.push(
          ...(
            await crudList(api, this.path, {
              filter: { [`${itemValuePropertyName}`]: this.value },
            })
          ).docs,
        );
      }
      this.list = _list;
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(v) {
        this.debounceToGetData();
      },
    },
  },
};
</script>

<style lang="scss">
.autoCompleted .v-icon {
  transform: rotate(0deg) !important;
}
</style>
